<template>
  <div class="conditions-container" :class="conditions.length ? 'conditions-has' : 'conditions-empty'">
	 <span class="label">筛选条件:</span>
	 <div class="tag-list">
		<div v-for="(item, index) in conditions" :key="index" @click.stop="delItem(item, index)">
			<span>{{ item.name }}</span>
			<i class="el-icon-close"></i>
		</div>
	 </div>
	 <span class="clear-all" @click="delAll" v-if="conditions.length > 0">清空筛选</span>
  </div>
</template>

<script>
export default {
  model: {
	prop: 'conditions',
	event: 'change'
  },
  data () {
	return {

	}
  },
  props: {
	conditions: {
		type: Array,
		default: () => []
	},
	searchData: {
		type: Array,
		default: () => []
	}
  },
  mounted () {

  },
  methods: {
	// 清除单项
	delItem(item, i) {
		const cur = this.searchData.find(x => x.field === item.field)
		delete item.children
		const clearItem = {...item, childField: cur ? cur.childField : [], val: '', name: '不限'}
		this.$emit('empty', clearItem)
		this.$emit('clearItem', clearItem)
	},
	// 清除所有
	delAll() {
		this.$emit('change', [])
		this.$emit('empty')
	}
  }
}
</script>

<style lang="scss" scoped>
.conditions-container {
	display: flex;
	padding: 5px 0;
	border-bottom: 1px solid #e4e7ed !important;
	height: 32px;
	font-size: 14px;
	&.conditions-empty {
		padding-bottom: 10px;
		align-items: center;
	}
	&.conditions-has {
		.label {
			// margin-top: -10px;
		}
	}
	.label {
		display: flex;
		width: 130px;
		justify-content: center;
		align-items: center;
		color: #666;
		background: #fff;
		margin-right: 20px;
	}
	.clear-all {
		margin-top: 8px;
		position: relative;
		font-size: 14px;
		color: #666666;
		cursor: pointer;
		min-width: 100px;
	}
	.tag-list {
		display: flex;
		flex-wrap: wrap;
		> div {
			margin-bottom: 10px;
			cursor: pointer;
			height: 30px;
			line-height: 30px;
			padding: 0 13px;
			font-size: 14px;
			display: inline-block;
			background: #fff;
			color: #969696;
			background-color: #f5f7fa;
			border: 1px solid #e8e8e8;
			border-radius: 4px;
			margin-right: 10px;
			> i {
				margin-left: 5px;
				&:hover {
					color: #ff6600;
				}
			}
		}
	}
}
</style>
